import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function LigamentInjuries() {
  useEffect(() => {
    document.title =
      "Ligament Injuries (ACL, PCL, Meniscus) | Viksha Health Care";
    const newMetaDescription =
      "Care for ligament injuries like ACL, PCL and meniscus problems at Viksha Health Care. Evaluation, imaging, and treatment options including rehab.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>
        Ligament Injuries (ACL, PCL, Meniscus)
      </h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Ligament-Injuries.avif" />
        </div>
        <div className="textareaofser">
          <h1>Ligament Injuries (ACL, PCL, Meniscus)</h1>

          <p>
            Ligaments are strong bands of tissue that connect bones and help
            stabilize joints. In the knee, the anterior cruciate ligament (ACL),
            posterior cruciate ligament (PCL), and meniscus play a vital role in
            maintaining joint stability and smooth movement. Injuries to these
            structures are common in sports, accidents, or sudden twisting
            movements.
          </p>

          <h5>What Causes These Injuries?</h5>
          <ul>
            <li>Sudden twisting or pivoting movements</li>
            <li>Direct impact to the knee</li>
            <li>Rapid changes in direction while running</li>
            <li>Landing awkwardly after a jump</li>
            <li>Road traffic accidents or falls</li>
          </ul>

          <h5>Common Symptoms</h5>
          <ul>
            <li>Pain and swelling in the knee</li>
            <li>A feeling of instability or the knee “giving way”</li>
            <li>Difficulty walking or bearing weight</li>
            <li>Reduced range of motion</li>
            <li>Locking or catching sensation in the knee (meniscus injury)</li>
          </ul>

          <h5>Evaluation and Diagnosis</h5>
          <p>
            A detailed clinical examination helps assess knee stability and
            identify the injured structure. Imaging tests may be recommended to
            confirm the diagnosis and evaluate the extent of damage.
          </p>

          <h5>Treatment Options</h5>

          <h6>Non-Surgical Management</h6>
          <p>
            Mild ligament sprains and some meniscus injuries can be treated
            without surgery. Treatment may include rest, knee support braces,
            medications, and physiotherapy to strengthen surrounding muscles and
            restore stability.
          </p>

          <h6>Physiotherapy and Rehabilitation</h6>
          <p>
            Structured rehabilitation is essential for recovery. Exercises focus
            on improving knee strength, balance, and flexibility, helping
            patients regain confidence in movement.
          </p>

          <h6>Surgical Treatment</h6>
          <p>
            In cases of complete ligament tears or significant meniscus damage
            causing instability or locking, surgical procedures may be
            recommended. These procedures aim to repair or reconstruct the
            injured structure and restore normal knee function.
          </p>

          <h5>Recovery and Return to Activity</h5>
          <p>
            Recovery depends on the severity of the injury and the type of
            treatment. Gradual return to sports and physical activity is guided
            to prevent re-injury and ensure safe healing.
          </p>

          <h5>Preventing Knee Ligament Injuries</h5>
          <ul>
            <li>Strengthening thigh and core muscles</li>
            <li>Proper warm-up before sports</li>
            <li>Using correct techniques during training</li>
            <li>Wearing appropriate footwear and protective gear</li>
          </ul>

          <p>
            Early assessment and appropriate management of ligament injuries
            help restore knee stability, reduce pain, and allow a safe return to
            daily and sports activities.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(LigamentInjuries);
